const getLineHeight = (fontSize, lineHeightMultiplier) => {
    try {
        return `${fontSize.split('px')[0] * lineHeightMultiplier}px`;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        return fontSize;
    }
};

const getLineHeightMultiplier = (fontSize, lineHeight) => {
    try {
        return parseFloat(lineHeight.split('px')[0] / fontSize.split('px')[0]);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        return 1;
    }
};

export {
    getLineHeight,
    getLineHeightMultiplier,
};
